/**
 * A class representing the One Time Vendor.
 */
export class OneTimeVendor {
    /**
     * Create a PO Sending Options.
     * @param {string} supplierName - The supplierName value.
     * @param {DeliveryAddress} address - The address value.
     * @param {string} phoneNumber - The phoneNumber value.
     * @param {string} supplierType - The supplierType value.
     */
    constructor(
        supplierName,
        address,
        phoneNumber,
        supplierType,
    ) {
        this._supplierName = supplierName;
        this._address = address;
        this._phoneNumber = phoneNumber;
        this._supplierType = supplierType;
    }

    /**
     * Get an JS object containing all the information about the One Time Vendor.
     * @return {{supplierName: string, address: DeliveryAddress, phoneNumber: string, supplierType: string}}
     */
    getOneTimeVendor() {
        return {
            supplierName: this._supplierName,
            address: this._address,
            phoneNumber: this._phoneNumber,
            supplierType: this._supplierType,
        };
    }

    /**
     * Get the supplier name value.
     * @return {string} The supplier name value.
     */
    get supplierName() {
        return this._supplierName;
    }

    /**
     * Set the supplier name value.
     * @param {string} value to set
     */
    set supplierName(value) {
        this._supplierName = value;
    }

    /**
     * Get the address value.
     * @return {DeliveryAddress} The address value.
     */
    get address() {
        return this._address;
    }

    /**
     * Set the address value.
     * @param {DeliveryAddress} value to set
     */
    set address(value) {
        this._address = value;
    }

    /**
     * Get the phone number value.
     * @return {string} The phone number value.
     */
    get phoneNumber() {
        return this._phoneNumber;
    }

    /**
     * Set the phone number value.
     * @param {string} value to set
     */
    set phoneNumber(value) {
        this._phoneNumber = value;
    }

    /**
     * Get the supplier type value.
     * @return {string} The supplier type value.
     */
    get supplierType() {
        return this._supplierType;
    }

    /**
     * Set the supplier type value.
     * @param {string} value to set
     */
    set supplierType(value) {
        this._supplierType = value;
    }
}

/**
 * @enum {string}
 */
OneTimeVendor.supplierTypes = {
    otv: 'OTV',
    cmv: 'CMV',
    mtv: 'MTV',
    generic: 'Generic',
};
